import { ErrorMessage, Field, } from 'formik'
import React from 'react'
import { Col, Row } from 'react-bootstrap'
import { ImageBucket_PHOTOS } from '../../../CommonUtilities/CommonFileUpload/ImageBucket'
import { config } from '../../../CommonUtilities/CommonUrl/CommonUrls'
import PersonalDetails from '../RegistrationTabs/PersonalDetails'
import CommunicationDetails from '../RegistrationTabs/CommunicationDetails'
import moment from 'moment'
import { FaMobileAlt } from 'react-icons/fa'

export default function PersonalDetailsReport(props) {

    const { showdata, Formik, preview, isEdit, isRead, Castes, handleCasteChange, selectedValue, subCastes, setSelectedsubcasteValue, selectedsubcasteValue, dscVerifiedPic } = props;

    return (
        <Row className='mb-2'>
            <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12} className='border'>
                <Row>
                    <Col xxl={9} xl={9} lg={9} md={12} sm={12} xs={12}>
                        {isEdit === true ? <div className='mt-2'>
                            <PersonalDetails Formik={Formik} isRead={isRead} selectedsubcasteValue={selectedsubcasteValue} subCastes={subCastes} Castes={Castes}
                                handleCasteChange={handleCasteChange} setSelectedsubcasteValue={setSelectedsubcasteValue}
                                selectedValue={selectedValue} hideCaste={true} />
                            <CommunicationDetails Formik={Formik} showdata={showdata} />
                        </div> :
                            <div className='p-3 profile-title table-responsive'>
                                <table className="table table-stripe table-bordered mb-0" style={{ borderColor: "#fbf7f7" }}>
                                    <tbody>
                                        <tr>
                                            <td style={{ width: "20%" }}>Aadhaar No.</td>
                                            <th style={{ width: "30%" }}>{showdata?.aadhaar_no}</th>

                                            <td style={{ width: "30%" }}>Mobile No.&nbsp; <FaMobileAlt /></td>
                                            <th style={{ width: "20%" }}>{showdata?.mobile_no}  </th>
                                        </tr>
                                        <tr>
                                            <td>
                                                Name :
                                            </td>
                                            <th>
                                                {showdata?.applicant_name}
                                            </th>
                                             <td>
                                               Sur Name :
                                            </td>
                                            <th>
                                                {showdata?.surname}
                                            </th>
                                            
                                           
                                            
                                        </tr>
                                        <tr>
                                        <td>
                                                Date of Birth (DD/MM/YYYY) :
                                            </td>
                                            <th>
                                                {moment(showdata?.dob).format('DD-MM-YYYY')}
                                            </th>
                                            <td>Gender | Marital status:</td>
                                            <th>
                                                {showdata?.gender} ,{showdata?.marital_status}</th>
                                           
                                        </tr>
                                        <tr>
                                             <td>
                                                Father's Name :
                                            </td>
                                            <th>
                                                {showdata?.father_name}
                                            </th><td>
                                                Mother's Name :
                                            </td>
                                            <th>
                                                {showdata?.mother_name}
                                            </th>
                                        </tr>
                                        <tr>
                                            <td>Caste:</td>
                                            <th>{showdata?.caste} ({showdata?.sub_caste_name})</th>
                                             <td>Are You Eligible for (EWS):</td>
                                            <th>{showdata?.is_ews === true ? "Yes" : "No"}</th>
                                        </tr>
                                         <tr>
                                           
                                            <td>E-mail</td>
                                    <th>{showdata?.email}</th>
                                     <td>Ex-Service Woman:</td>
                                            <th>{showdata?.is_ex_service_men === true ? <>Yes ,{showdata?.ex_service}</> : "No"}</th>
                                        </tr>
                                        <tr>
                                       
                                           
                                           
                                            <td>If Differently Abled(PH)</td>
                                            <th>{showdata?.is_ph === true ? <React.Fragment>
                                                {showdata?.is_vh === true && <React.Fragment>VISUALLY IMPAIRED(VI)  : {showdata?.vh_percentage}%</React.Fragment>}<br />
                                                {showdata?.is_hi === true && <React.Fragment>HEARING IMPAIRED(HI)  : {showdata?.hi_percentage}%</React.Fragment>}<br />
                                                {showdata?.is_oh === true && <React.Fragment>ORTHOPEDICALLY HANDICAPPED(OH)  : {showdata?.oh_percentage}%</React.Fragment>}<br />
                                                {showdata?.is_mi === true && <React.Fragment>MENTAL DISABILITY / MULTIPLE DISABILITY(MD)  : {showdata?.mi_percentage}%</React.Fragment>}<br />
                                               
                                            </React.Fragment> : 'No'}
                                            </th>
                                             <td>Communication Details:</td>
                                            <th>
                                                {showdata?.is_andhra === true ?
                                                    <React.Fragment>
                                                        {showdata?.address},Door No.{showdata?.door_no},
                                                        {showdata?.village_name} {showdata?.mandal_name} - {showdata?.pin_code} ,
                                                        {showdata?.dist_name} dist.,
                                                    </React.Fragment> :
                                                    <React.Fragment>
                                                        {showdata?.address},Door No.{showdata?.door_no},
                                                        {showdata?.mandal_name} - {showdata?.pin_code} ,
                                                        {showdata?.dist_name} dist.,{showdata?.state_name}
                                                    </React.Fragment>}
                                            </th>
                                        </tr>
                                        <tr>
                                            
                                            {/* <td>Are You Claiming Meritorious in Sports as per GO No 74</td>
                                            <th>{showdata?.is_sports === true ? 'Yes' : 'No'}</th> */}
                                            {/* </tr>
                                        <tr> */}
                                           

                                        </tr>
                                         {/* <td>Communication Details:</td>
                                            <th>
                                                {showdata?.is_andhra === true ?
                                                    <React.Fragment>
                                                        {showdata?.address},Door No.{showdata?.door_no},
                                                        {showdata?.village_name} {showdata?.mandal_name} - {showdata?.pin_code} ,
                                                        {showdata?.dist_name} dist.,
                                                    </React.Fragment> :
                                                    <React.Fragment>
                                                        {showdata?.address},Door No.{showdata?.door_no},
                                                        {showdata?.mandal_name} - {showdata?.pin_code} ,
                                                        {showdata?.dist_name} dist.,{showdata?.state_name}
                                                    </React.Fragment>}
                                            </th> */}
                                        {/* <tr> <td> Are you in Government/Residential Schools/Apreis/Twreis/Swreis ?</td>
                                            <th>{showdata?.is_gov_school === true ? <React.Fragment>
                                                Yes, {showdata?.management_short_name} .
                                            </React.Fragment> : showdata?.is_gov_school === false ? 'No' : "-"} </th>
                                            <td colSpan={2}></td></tr> */}
                                    </tbody>
                                </table>
                            </div>
                            }
                    </Col>
                    <Col xxl={3} xl={3} lg={3} md={12} sm={12} xs={12} className='border-start'>
                        <div className='profile-photo  p-4'>
                            <img src={Formik?.values?.imgPath ?
                                config.url.FILE_DOWNLOAD_URL + Formik?.values?.imgPath
                                : showdata?.img_path ? config.url.FILE_DOWNLOAD_URL + showdata?.img_path :
                                    `${process.env.PUBLIC_URL}/img/c1.png`
                            } className='img-flui w-75 m-auto d-block border border-dark' alt='' style={{ height: '227px', width: '133px' }} />
                            {/* {console.log("dscVerifiedPic,preview", dscVerifiedPic, preview)} */}
                            {/* {(preview !== true) && ( */}
                            {(preview !== true) && ( 
                                <div className="input-group mt-4">
                                    <Field type='file' name="candidatePhoto" className="form-control w-100" id="inputGroupFile02"
                                        onChange={(e) => {
                                            let candidateId = ''
                                            let filename = candidateId + "_candidate_photo"
                                            ImageBucket_PHOTOS(e, Formik, "imgPath", filename)
                                        }} />
                                    <Field type="hidden" name="imgPath" />
                                    <br />
                                    <ErrorMessage name="candidatePhoto" component="div" className="text-error" />
                                </div>
                                )}
                                {/* )} */}
                        </div>
                    </Col>
                </Row>
                {preview !== true ?
                    <Row>
                        <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                            <font color="red"
                                style={{ fontWeight: 'bold' }}>Note:</font>
                            <ol>
                                <li>Paste the Photo on any
                                    white paper and Sign below(<font color="red"
                                        style={{ fontWeight: 'bold' }}>sign in BLACK INK only</font>).
                                    Ensure that the signature is within the box. Scan the
                                    required size containing photograph and signature. Please do
                                    not scan the complete page. <br /></li>
                                <li>The entire image
                                    consisting of the photo along with the signature is required
                                    to be scanned and stored in (<font color="red"
                                        style={{ fontWeight: 'bold' }}>*.jpg/jpeg</font>) format on local machine.
                                    Ensure that the size of the scanned image is not more than
                                    150 kb.If the size of the file is more than (<font color="red"
                                        style={{ fontWeight: 'bold' }}> 150 kb </font>), then adjust
                                    the settings of the scanner such as the dpi resolution, no.
                                    of colours etc., during the process of scanning. <br /></li>
                                <li>Applications with no
                                    photo/ unclear photo/ inadequate size photograph will not be
                                    accepted. Hall-Ticket will not be issued to such candidates.
                                    <br /></li>
                                <li>Complaints relating to
                                    mismatch of photograph and candidate details will not be
                                    accepted after submitting of application at any cost. <br />
                                </li>
                            </ol>
                        </Col>
                    </Row> : ""}
            </Col>
        </Row>
    )
}
